import React, {useEffect, useState} from 'react';
import classnames from "classnames";
import TInputForm from "../common/TInputForm";
import ViewChannelSelection from "./ViewChannelSelection";
import {findViewChannelLabel, validateCategoryName} from "./Utils";

function CategoryButtons(props) {
  const { category, hasChild, onMove, onAppend, onEdit, onEditInfo, onRemove } = props;
  const [removeDisabled, setRemoveDisabled] = useState(false)

  function handleAppend(e) {
    e.preventDefault();
    onAppend(category);
  }

  function handleEdit(e) {
    e.preventDefault();
    onEdit(category.id);
  }

  function handleSetting(e) {
    e.preventDefault();
    e.stopPropagation()
    onEditInfo(category);
  }

  function handleMove(e) {
    e.preventDefault();
    onMove();
  }

  function handleRemove(e) {
    e.preventDefault();
    if (removeDisabled) {
      return;
    }
    onRemove(category.id);
  }

  useEffect(() => {
    setRemoveDisabled(hasChild || category.entries > 0)
  }, [category, hasChild])

  return (
    <div className="info_btn">
      {category.depth === 1 && <a href="#" className="btn_post" onClick={handleAppend}>추가</a>}
      <a href="#" className="btn_post" onClick={handleEdit}>수정</a>
      <a href="#" className="btn_post" onClick={handleSetting}>관리</a>
      <a href="#" className="btn_post" onClick={handleMove}>이동</a>
      <a href="#" className={classnames("btn_post", {"disabled": removeDisabled})} onClick={handleRemove}>삭제</a>
    </div>
  );
}


function EditForm({ category, onClose, onSubmit }) {
  const [name, setName] = useState(category.name)
  const [viewChannel, setViewChannel] = useState(category.viewChannel)
  const [validated, setValidated] = useState(false)

  function handleSubmit(e) {
    e.preventDefault();

    if (!validated) {
      return false;
    }

    onSubmit(name.trim(), viewChannel);
  }

  useEffect(() => {
    setValidated(
      (name.trim() != category.name || viewChannel != category.viewChannel) &&
      validateCategoryName(name)
    )
  }, [name, viewChannel])

  return (
    <form className={"edit_item"} onSubmit={e => handleSubmit(e)} onReset={e => onClose()}>
      <label className="lab_tf">
        <strong className="screen_out">카테고리 Label</strong>
        <TInputForm
          className="tf_blog" type="text"
          focus={true} maxlength="40"
          value={name} onChange={setName}
        />
      </label>

      <ViewChannelSelection
        selected={viewChannel}
        selectChannel={setViewChannel}
      />

      <div className="order_btn">
        <button type="reset" className="btn_cancel">취소</button>
        <button type="submit" disabled={!validated} className={classnames('btn_default', { 'btn_off':!validated})}>확인</button>
      </div>
    </form>
  );
}


export function SubCategoryToggleButton(props) {
  const { hasChild, onClick } = props;
  return (
    <label className={classnames("lab_btn lab_cate", {'lab_fold' : hasChild})}>
      <span className="wrap_arr">
        <span className="ico_blog"/>
      </span>
      <input type="button" className="btn_g" value="open sub category" onClick={onClick}/>
    </label>
  );
}


export function CategoryContent(props) {
  const {
    isEditMode, category, hasChild, nodeCount, viewChannels, connectDragSource,
    onMove, onAppend, onEdit, onEditInfo, onRemove, onEditSubmit, onEditClose
  } = props;

  let smallLabel = '0';
  if (category.entries && category.entries > 0) {
    const reg = /(^[+-]?\d+)(\d{3})/;
    smallLabel = category.entries + '';
    while (reg.test(smallLabel)) {
      smallLabel = smallLabel.replace(reg, '$1' + ',' + '$2');
    }
  }

  if (isEditMode) {
    return (
      <EditForm
        category={category}
        onSubmit={onEditSubmit}
        onClose={onEditClose}
      />
    );
  } else {
    return (
      <div className="basic_item">
        {(nodeCount <= 300) &&  connectDragSource(
          <div className="wrap_drag">
            <span className="ico_blog ico_drag"/>
          </div>
        )}
        <div style={{display:'inline'}}>
          <div className="wrap_name">
            <span className="txt_name">{category.name}</span>
            <span className="txt_count">({smallLabel})</span>
          </div>
          {category.viewChannel &&
          <span className="txt_cate">{findViewChannelLabel(category.viewChannel, viewChannels)}</span>
          }

          <CategoryButtons
            category={category}
            hasChild={hasChild}
            onMove={onMove}
            onAppend={onAppend}
            onEdit={onEdit}
            onEditInfo={onEditInfo}
            onRemove={onRemove}
          />
        </div>
      </div>
    );
  }
}
